import styled from "styled-components";

export const PageRoot = styled.div`
  width: 100%;
  padding: 96px clamp(18px, 3vw, 40px) 72px;

  @media (max-width: 991px) {
    padding-top: 82px;
  }
`;

export const Header = styled.div`
  width: 100%;
  min-height: 220px;
  border-radius: 18px;
  padding: clamp(26px, 4vw, 46px);
  margin-bottom: 34px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(240px, 360px);
  gap: 28px;
  align-items: end;
  background:
    linear-gradient(120deg, rgba(21, 93, 252, 0.16), rgba(21, 93, 252, 0) 48%),
    ${({ theme }) => theme.palette.colors.surfaceElevatedStrong};
  box-shadow: 0 24px 70px ${({ theme }) => theme.palette.colors.shadowStrong};

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

export const HeaderContent = styled.div`
  max-width: 780px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HeaderEyebrow = styled.div`
  width: fit-content;
  min-height: 26px;
  border-radius: 999px;
  padding: 5px 10px;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 13px;
  font-weight: 800;
  line-height: 16px;
  letter-spacing: 0;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(40px, 5vw, 68px);
  line-height: 0.98;
  letter-spacing: 0;
  color: ${({ theme }) => theme.palette.colors.text};
`;

export const Subtitle = styled.p`
  margin: 0;
  max-width: 640px;
  font-size: 18px;
  line-height: 1.55;
  color: ${({ theme }) => theme.palette.colors.muted};
`;

export const HeaderMeta = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1px;
  border-radius: 14px;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.colors.borderSoft};

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const StatItem = styled.div`
  min-width: 0;
  min-height: 84px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedSoft};
`;

export const StatValue = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: clamp(24px, 3vw, 36px);
  font-weight: 800;
  line-height: 1;
  color: ${({ theme }) => theme.palette.colors.text};
`;

export const StatLabel = styled.div`
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: 0;
  color: ${({ theme }) => theme.palette.colors.subdued};
  text-transform: uppercase;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 34px 24px;

  & > * {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`;

export const EmptyState = styled.div`
  padding: 36px 0;
  font-size: 17px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.colors.muted};
`;
